<template lang="pug">
.map
  #myMap
  v-btn.edit(
    @click="toogleDrawMode(false)",
    v-if="enableEditDrawing",
    color="primary",
    rounded
  ) Enregistrer
  .infoPosition(v-if="prelevementToDo && prelevementToDo.length > 0")
    v-progress-circular(
      :rotate="360",
      :size="100",
      :width="15",
      :value="(prelevementDone.length / prelevementToDo.length) * 100",
      color="green",
      @click="restart"
    ) 
      div
        div {{ prelevementDone.length + ' / ' + prelevementToDo.length }}
        .diameter {{ Math.floor(cellSide) * 2 }}m Ø
  .tools
    v-btn(
      fab,
      @click="getMyPosition",
      :color="enableRecording ? 'red' : ''",
      :dark="enableRecording",
      v-if="!enableEditDrawing"
    ) 
      v-icon mdi-compass-outline

  v-dialog(v-model="dialog")
    v-card 
      v-btn(@click="dialog = false") close
</template>

<script>
import _ from "lodash";

import mapboxgl from "mapbox-gl";
import * as turf from "@turf/turf";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";

export default {
  name: "Map",

  data: () => {
    return {
      dialog: false,
      geolocation: null,
      position: [3.2625768, 48.5706674],
      heading: 0,
      altitude: 0,
      map: null,
      watchID: null,
      marker: null,
      circle: null,
      markers: [],
      circleSize: 10,
      circles: [],
      draw: null,
      drawing: false,
      featuresCoord: [],
      prelevementToDo: [],
      prelevementToDoManual: [],
      prelevementDone: [],
      myZone: [],
      positions: [],
      accuracy: 10,
      accuracys: [],
      enableGeolocation: true,
      enableRecording: false,
      myDraw: null,
      mySearch: null,
      enableEditDrawing: false,
      cellSideMax: 10,
      compass: 0,
      pitch: 0,
      pointDegree: 0,
      zoom: 18,
      isIOS: true,
      compassLoaded: false,
    };
  },
  props: ["drawLoaded", "allowEditing", "editDrawing", "parcelleId"],

  mounted: function () {
    this.$nextTick(function () {
      mapboxgl.accessToken =
        "pk.eyJ1IjoiZ2F1emlsYSIsImEiOiJjazV1ZW5kdTEwMWhjM2ZsYmFoeXpxM2FoIn0.tgX19HbpwIlH0DMArtq-1Q";

      this.map = new mapboxgl.Map({
        container: "myMap", // container ID
        //style: "mapbox://styles/mapbox/light-v10",
        style: "mapbox://styles/mapbox/satellite-streets-v11", // style URL
        center: this.position,
        zoom: 3,
        //projection: "globe",
      });
      this.mySearch = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        reverseGeocode: true,
        flyTo: true,
        //marker: false,
        collapsed: true,
        clearAndBlurOnEsc: true,
        clearOnBlur: true,
      });

      this.map.addControl(
        new mapboxgl.NavigationControl({
          //showZoom: false,
        })
      );

      this.draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          line_string: true,
          trash: true,
          point: true,
        },
      });

      this.map.on("draw.create", this.updateArea);
      this.map.on("draw.delete", this.updateArea);
      this.map.on("draw.update", this.updateArea);

      this.map.on("load", () => {
        this.map.setFog({});
        this.map.addSource("accuracys", {
          type: "geojson",
          data: this.dataAccuracys,
        });
        this.map.addSource("positions", {
          type: "geojson",
          data: this.dataPositions,
        });
        this.map.addSource("zone", {
          type: "geojson",
          data: this.dataZone,
        });
        this.map.addSource("positionsPath", {
          type: "geojson",
          data: this.dataPositionsPath,
        });
        this.map.addSource("prelevementToDo", {
          type: "geojson",
          data: this.dataPrelevementToDo,
        });
        this.map.addSource("prelevementDone", {
          type: "geojson",
          data: this.dataPrelevementDone,
        });

        this.map.addLayer({
          id: "positionsHistory",
          source: "positions",
          type: "circle",
          paint: {
            "circle-radius": 5,
            "circle-color": "#0080ff",
            "circle-opacity": 1,
            "circle-stroke-width": 1,
            "circle-stroke-color": "white",
          },
          filter: ["==", "modelId", 1],
        });

        this.map.addLayer({
          id: "positionsAccuracy",
          source: "accuracys",
          type: "fill",
          layout: {},
          paint: {
            "fill-color": "#0080ff",
            "fill-opacity": 0.2,
          },
        });
        this.map.addLayer({
          id: "prelevementToDo",
          source: "prelevementToDo",
          type: "fill",
          layout: {},
          paint: {
            "fill-color": "white",
            "fill-opacity": 0.5,
          },
        });
        this.map.addLayer({
          id: "prelevementDone",
          source: "prelevementDone",
          type: "fill",
          layout: {},
          paint: {
            "fill-color": "#00ff00",
            "fill-opacity": 0.2,
          },
        });
        this.map.addLayer({
          id: "myZone",
          source: "zone",
          type: "line",
          layout: {},
          paint: {
            "line-color": "white",
            "line-width": 2,
          },
        });
        this.map.addLayer({
          id: "myPositionPath",
          source: "positionsPath",
          type: "line",
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#0080ff",
            "line-width": 1,
          },
        });

        this.map.on("click", "prelevementToDo", (e) => {
          e.preventDefault();
          this.manualUpdatePosition(e);
        });
        this.map.on("touchStart", "prelevementToDo", (e) => {
          e.preventDefault();
          this.manualUpdatePosition(e);
        });
        this.map.on("click", () => {});
        this.map.on("touchStart", () => {});
        //this.loadCadastreFromUrl();
      });
    });
  },
  computed: {
    features() {
      return _.map(this.featuresCoord, (coordinates) => {
        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates,
          },
          properties: {
            modelId: 1,
          },
        };
      });
    },

    dataZone() {
      return {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: this.myZone,
        },
      };
    },
    dataPositionsPath() {
      return {
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: _.concat(this.positions),
        },
      };
    },
    dataPositions() {
      return {
        type: "FeatureCollection",
        features: _.map(this.positions, (coordinates) => {
          return {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates,
            },
            properties: {
              modelId: 1,
            },
          };
        }),
      };
    },
    dataPrelevementToDo() {
      return {
        type: "FeatureCollection",
        features: _.map(this.prelevementToDo, (coordinates) => {
          return coordinates;
        }),
      };
    },
    dataPrelevementDone() {
      return {
        type: "FeatureCollection",
        features: _.map(this.prelevementDone, (coordinates) => {
          return coordinates;
        }),
      };
    },
    dataAccuracys() {
      return {
        type: "FeatureCollection",
        features: _.map(this.accuracys, (coordinates) => {
          return coordinates;
        }),
      };
    },
    cellSide() {
      const smallParcelle = this.getSmallerPolygon(this.parcelle);
      return Math.min(
        Math.max(this.getCellSide([smallParcelle], 40) / 2 - 0.25),
        this.cellSideMax
      );
    },
    parcelle() {
      return !this.enableEditDrawing
        ? _.get(this.myDraw, "features[0].geometry.coordinates[0]")
        : [];
    },

    manualLines() {
      let manualLines = [];
      const minSpaceSize = this.getCellSide([this.parcelle], 40);

      _.each(this.myDraw.features, (feature, index) => {
        if (index > 0 && feature.geometry.type !== "Point") {
          manualLines.push(
            this.getlineGrid(feature.geometry.coordinates, minSpaceSize)
          );
        }
      });
      return _.flatMap(manualLines);
    },
    manualPoints() {
      return _.compact(
        _.flatMap(_.get(this.myDraw, "features"), (feature) => {
          return feature.geometry.type === "Point"
            ? this.getZonefromPosition(
                feature.geometry.coordinates,
                this.cellSide
              )
            : null;
        })
      );
    },
  },
  methods: {
    setZoom(value) {
      this.zoom = value;
    },
    restart() {
      if (window.confirm("Recommencer le prélevement ?")) {
        this.deleteGeoloc();
        this.updatePrelevementDone([]);
      }
      this.fitpolygonBounds(this.myZone);
    },
    fitpolygonBounds(polygon) {
      if (polygon && polygon.length > 0) {
        this.map.fitBounds(turf.bbox(turf.polygon(polygon)), {
          padding: { top: 50, left: 50, right: 50, bottom: 50 },
          duration: 0,
        });
      }
    },
    toogleDrawMode(value) {
      //const test = JSON.stringify(this.myDraw);
      //navigator.clipboard.writeText(test);

      if (value != null) {
        this.enableEditDrawing = value;
      } else {
        this.enableEditDrawing = !this.enableEditDrawing;
      }
      if (!this.enableEditDrawing) {
        this.$emit("update", this.myDraw);
      }
    },
    newDrawing() {
      this.myDraw = null;
    },
    loadCadastreFromUrl() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const myDraw = urlParams.get("myDraw");
      const localStorageMyDraw = JSON.parse(localStorage.getItem("myDraw"));
      if (myDraw !== null) {
        this.myDraw = JSON.parse(myDraw);
        this.enableEditDrawing = false;
      } else if (localStorageMyDraw) {
        this.myDraw = JSON.parse(localStorage.getItem("myDraw"));
        this.enableEditDrawing = false;
      } else {
        this.myDraw = null;
        this.enableEditDrawing = true;
      }
    },
    startDrawing() {},
    deletePoints() {
      this.featuresCoord = [];
      this.prelevementToDo = [];
      this.prelevementToDoManual = [];

      this.myZone = [];
    },
    getCellSide(polygon, nbPoints) {
      return Math.sqrt(turf.area(turf.polygon(polygon)) / nbPoints);
    },
    getPointsInArea(polygon, nbPoints) {
      const poly = turf.polygon(polygon);

      var grid = turf.pointGrid(
        turf.bbox(poly),
        this.getCellSide(polygon, nbPoints) / 1000,
        { units: "kilometers", mask: poly }
      );
      return _.map(_.get(grid, "features"), (feature) => {
        return feature.geometry.coordinates;
      });
    },
    generateAndTrimEquidistantValues(count) {
      const interval = 100 / (count - 1);
      const equidistantValues = [];
      for (let i = 0; i < count; i++) {
        equidistantValues.push(i * interval);
      }
      // Supprimer la première et la dernière valeur
      equidistantValues.shift(); // Supprimer la première valeur
      equidistantValues.pop(); // Supprimer la dernière valeur
      return equidistantValues;
    },
    getDistance(from, to) {
      return turf.distance(turf.point(from), turf.point(to), {
        units: "kilometers",
      });
    },
    getPointsInLine(coords, minSpaceSize) {
      const allPoints = [];
      _.each(coords, (center, index) => {
        allPoints.push(center);
        const currentIndex = index + 1;
        if (currentIndex < coords.length) {
          const subDivision = Math.floor(
            (this.getDistance(coords[currentIndex], coords[index]) /
              minSpaceSize) *
              1000
          );

          _.each(
            this.generateAndTrimEquidistantValues(subDivision),
            (pourcentage) => {
              allPoints.push(
                this.getPointOnLine(
                  coords[index],
                  coords[currentIndex],
                  pourcentage
                )
              );
            }
          );
        }
      });
      return allPoints;
    },
    getPointOnLine(point1, point2, pourcentage) {
      const x1 = point1[0];
      const x2 = point2[0];
      const y1 = point1[1];
      const y2 = point2[1];
      const a = (y2 - y1) / (x2 - x1);
      const b = -(a * x1 - y1);
      const xPourcent = ((x2 - x1) / 100) * pourcentage + x1;
      const yPourcent = a * xPourcent + b;
      return [xPourcent, yPourcent];
    },
    updateArea(e) {
      setTimeout(() => {
        const currentDraw = this.draw.getAll();
        if (currentDraw.features.length > 0) {
          this.myDraw = this.draw.getAll();
          const firstFeatureType = _.get(
            this.myDraw,
            "features[0].geometry.type"
          );
          if (firstFeatureType === "Polygon") {
            const polygon = _.get(
              this.myDraw,
              "features[0].geometry.coordinates[0]"
            );
            const nbFeatures = _.get(this.myDraw, "features").length;
            //if (polygon.length === 5 && nbFeatures >= 1) {
            //  this.draw.deleteAll();
            //  const smallParcelle = this.getSmallerPolygon(polygon);
            //  const fakeM = turf.lineString(this.getFakeM(smallParcelle));
            //  const fakeW = turf.lineString(this.getFakeW(smallParcelle));
            //  this.myDraw.features.splice(1, 10);
            //  this.myDraw.features.push(fakeM);
            //  this.myDraw.features.push(fakeW);
            //  this.draw.set(this.myDraw);
            //}
          } else {
            this.myDraw = null;
            this.draw.deleteAll();
          }
        } else {
          this.myDraw = null;
        }
      }, 0);
    },
    createChamp(polygon) {
      this.createPolygonGrid(polygon);
    },
    createGrid() {
      if (
        (this.manualLines && this.manualLines.length > 0) ||
        (this.manualPoints && this.manualPoints.length > 0)
      ) {
        this.prelevementToDo = _.concat(this.manualLines, this.manualPoints);
      } else if (this.parcelle) {
        const smallParcelle = this.getSmallerPolygon(this.parcelle);
        this.prelevementToDo = this.createPolygonGrid(smallParcelle);
      } else {
        this.prelevementToDo = [];
      }
    },
    getSmallerPolygon(polygon) {
      return turf.getCoords(
        turf.transformScale(turf.polygon([polygon]), 0.9)
      )[0];
    },
    getFakeM(polygon) {
      const p1 = polygon[0];
      const p2 = this.getPointOnLine(polygon[3], polygon[2], 25);
      const p3 = this.getPointOnLine(polygon[0], polygon[1], 50);
      const p4 = this.getPointOnLine(polygon[2], polygon[3], 25);
      const p5 = polygon[1];
      return [p1, p2, p3, p4, p5];
    },
    getFakeW(polygon) {
      const p1 = polygon[3];
      const p2 = this.getPointOnLine(polygon[0], polygon[1], 25);
      const p3 = this.getPointOnLine(polygon[2], polygon[3], 50);
      const p4 = this.getPointOnLine(polygon[0], polygon[1], 75);
      const p5 = polygon[2];
      return [p1, p2, p3, p4, p5];
    },
    getlineGrid(coords, minSpaceSize) {
      return _.map(this.getPointsInLine(coords, minSpaceSize), (center) => {
        return this.getZonefromPosition(center, this.cellSide);
      });
    },
    createPolygonGrid(polygon) {
      return _.map(this.getPointsInArea([polygon], 40), (center) => {
        return this.getZonefromPosition(center, this.cellSide);
      });
    },
    getZonefromPosition(position, radius) {
      return turf.circle(position, radius / 1000, {
        steps: 30,
        units: "kilometers",
        properties: { id: position[0] + "+" + position[1] },
      });
    },

    showBatteryPourcentage() {
      // Vérifier si l'API Battery Status est prise en charge
      if ("getBattery" in navigator) {
        navigator.getBattery().then(function (battery) {
          // Obtenir le pourcentage de la batterie
          var batteryPercentage = battery.level * 100;

          // Afficher le pourcentage de la batterie
          alert("Pourcentage de la batterie : " + batteryPercentage + "%");

          // Vous pouvez également surveiller les modifications de l'état de la batterie
          battery.addEventListener("levelchange", function () {
            // Mettre à jour le pourcentage de la batterie lorsque cela change
            batteryPercentage = battery.level * 100;
            alert(
              "Nouveau pourcentage de la batterie : " + batteryPercentage + "%"
            );
          });
        });
      } else {
        alert(
          "L'API Battery Status n'est pas prise en charge par ce navigateur."
        );
      }
    },

    getMyPosition() {
      if (!this.compassLoaded && !this.enableRecording) {
        this.initCompass();
      }
      this.toggleEnableRecording();
      //this.updatePosition();
      this.updatePosition2();
    },
    toggleEnableRecording() {
      this.enableRecording = !this.enableRecording;
      if (!this.enableRecording) {
        this.map.setBearing(0);
        this.map.setPitch(0);
        this.deleteGeoloc();
      }
    },
    deleteGeoloc() {
      this.enableRecording = false;
      this.positions = [];
      this.accuracys = [];
    },
    manualUpdatePosition(e) {
      if (this.prelevementToDo && this.prelevementToDo.length > 0) {
        const position = [e.lngLat.lng, e.lngLat.lat];
        this.checkPositionMatching(position);
      }
    },
    updatePosition() {
      if (this.enableRecording) {
        var options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 1000,
        };
        window.navigator.geolocation.getCurrentPosition(
          (position) => {
            this.position = [
              position.coords.longitude,
              position.coords.latitude,
            ];
            this.accuracy = position.coords.accuracy;
            this.geolocation = position;
            this.cameraAfterGeoloc();
          },
          () => {
            //todo remove this code to alert
            this.position = [
              this.position[0] + Math.random() * 0.0001,
              this.position[1] + Math.random() * 0.0001,
            ];
            this.accuracy = Math.random() * 10 + 5;
            this.geolocation = this.position;
            this.cameraAfterGeoloc();
          },
          options
        );
        setTimeout(this.updatePosition, 2000);
      }
    },
    updatePosition2() {
      if (this.enableRecording) {
        var options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 1000, // Utilise les données de position du cache si elles ont moins d'une minute
        };
        this.watchID = window.navigator.geolocation.watchPosition(
          (position) => {
            this.position = [
              position.coords.longitude,
              position.coords.latitude,
            ];
            this.accuracy = position.coords.accuracy;
            this.geolocation = position;
            this.cameraAfterGeoloc();
          },
          () => {
            window.navigator.geolocation.clearWatch(this.watchID);
            this.toggleEnableRecording();
            alert(
              "L'accès à la géolocalisation de votre appareil n'est pas disponible. Votre position ne pouvant être déterminé, nous vous invitons à vous repérer manuellement."
            );
          },
          options
        );
      } else {
        window.navigator.geolocation.clearWatch(this.watchID);
      }
    },
    cameraAfterGeoloc() {
      //this.map.flyTo({ center: this.position, essential: true });
      this.map.setCenter(this.position);
      //this.map.setZoom(19);
      //const options = {
      //  steps: 10,
      //  units: "kilometers",
      //};
      //const circle = turf.circle(this.position, 0.1, options);
      ////console.log(circle.geometry.coordinates);
      //this.fitpolygonBounds(circle.geometry.coordinates);
    },
    initCompass() {
      this.isIOS =
        navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
        navigator.userAgent.match(/AppleWebKit/);
      this.init();
    },
    startCompass() {
      if (typeof DeviceOrientationEvent.requestPermission === "function") {
        DeviceOrientationEvent.requestPermission()
          .then((response) => {
            if (response === "granted") {
              window.addEventListener("deviceorientation", this.handler, true);
              this.compassLoaded = true;
            } else {
              alert(
                "L'accès à l'orientation de votre appareil n'a pas été donné. Vous devez accepter son usage ou alors nous vous invitons à vous orienter manuellement."
              );
            }
          })
          .catch(() =>
            alert(
              "L'accès à l'orientation de votre appareil n'est pas disponible. La boussole ne pouvant être activé nous vous invitons à vous orienter manuellement."
            )
          );
      } else {
        alert(
          "L'accès à l'orientation de votre appareil n'est pas disponible. La boussole ne pouvant être activé nous vous invitons à vous orienter manuellement."
        );
      }
    },
    handler(e) {
      if (this.enableRecording) {
        this.pitch = e.beta || 0;
        this.compass = e.webkitCompassHeading || Math.abs(e.alpha - 360);
      } else {
        this.pitch = 0;
        this.compass = 0;
      }
    },

    calcDegreeToPoint(latitude, longitude) {
      // Qibla geolocation
      const point = {
        lat: 21.422487,
        lng: 39.826206,
      };

      const phiK = (point.lat * Math.PI) / 180.0;
      const lambdaK = (point.lng * Math.PI) / 180.0;
      const phi = (latitude * Math.PI) / 180.0;
      const lambda = (longitude * Math.PI) / 180.0;
      const psi =
        (180.0 / Math.PI) *
        Math.atan2(
          Math.sin(lambdaK - lambda),
          Math.cos(phi) * Math.tan(phiK) -
            Math.sin(phi) * Math.cos(lambdaK - lambda)
        );
      return Math.round(psi);
    },
    locationHandler(position) {
      const { latitude, longitude } = position.coords;
      this.pointDegree = this.calcDegreeToPoint(latitude, longitude);

      if (this.pointDegree < 0) {
        this.pointDegree = this.pointDegree + 360;
      }
    },
    init() {
      navigator.geolocation.getCurrentPosition(this.locationHandler);

      window.addEventListener("deviceorientationabsolute", this.handler, true);

      this.startCompass();
    },
    checkPositionMatching(position) {
      _.each(this.prelevementToDo, (circle) => {
        const point = turf.point(position);
        if (turf.booleanContains(circle, point)) {
          const isNewPrelevement =
            _.findIndex(this.prelevementDone, (prelevement) => {
              return prelevement.properties.id === circle.properties.id;
            }) === -1;
          if (isNewPrelevement) {
            if (window.confirm("Valider le prélèvement ?")) {
              this.prelevementDone.push(circle);
            } else {
            }
          }
        }
      });
    },
    setSourceMapData(source, data) {
      if (this.map && source !== null && data !== null) {
        this.map.getSource(source).setData(data);
      }
    },
    updatePrelevementDone(newValue) {
      this.prelevementDone = newValue;
    },
  },
  watch: {
    prelevementDone: {
      handler(newData) {
        localStorage.setItem(
          "prelevementDone-" + this.parcelleId,
          JSON.stringify(newData)
        );
      },
      deep: true, // Permet de surveiller les changements profonds dans l'objet
    },
    editDrawing() {
      this.toogleDrawMode(this.editDrawing);
    },
    drawLoaded() {
      this.myDraw = this.drawLoaded;
      this.deleteGeoloc();
      this.deletePoints();
      this.enableEditDrawing = false;
    },
    zoom() {
      if (this.map) {
        this.map.setZoom(this.zoom);
      }
    },
    enableRecording() {
      //if (this.enableRecording) {
      //  this.map.easeTo({
      //    padding: { top: 300 },
      //    duration: 1000, // In ms. This matches the CSS transition duration property.
      //  });
      //} else {
      //  this.map.easeTo({
      //    padding: { top: 0 },
      //    duration: 1000, // In ms. This matches the CSS transition duration property.
      //  });
      //}
    },
    compass() {
      if (this.map) {
        this.map.setBearing(this.compass);
      }
    },
    pitch() {
      if (this.map) {
        this.map.setPitch(this.pitch);
      }
    },
    enableEditDrawing() {
      this.$emit("mode", this.enableEditDrawing);
      if (this.enableEditDrawing) {
        this.fitpolygonBounds(this.myZone);
        this.deleteGeoloc();
        this.deletePoints();
        this.updatePrelevementDone([]);
        this.map.addControl(this.mySearch, "bottom-right");
        this.map.addControl(this.draw, "bottom-left");

        if (this.myDraw) {
          this.draw.set(this.myDraw);
        }
      } else {
        this.deleteGeoloc();
        this.deletePoints();
        this.updatePrelevementDone([]);
        this.map.removeControl(this.draw);
        this.map.removeControl(this.mySearch);
      }
    },
    parcelle() {
      if (this.parcelle) {
        const storedData = localStorage.getItem(
          "prelevementDone-" + this.parcelleId
        );
        if (storedData) {
          this.prelevementDone = JSON.parse(storedData);
        }
        this.createGrid();
        this.myZone = [this.parcelle];
        if (this.myZone && this.myZone.length > 0) {
          this.map.fitBounds(turf.bbox(turf.polygon(this.myZone)), {
            padding: { top: 50, left: 50, right: 50, bottom: 50 },
            duration: 0,
          });
        }
      }
    },

    geolocation() {
      const center = this.position;
      //this.map.panTo(center);
      this.positions = [center]; //.push(center);
      this.accuracys = [];
      this.accuracys.push(this.getZonefromPosition(center, this.accuracy));
    },
    dataZone() {
      this.setSourceMapData("zone", this.dataZone);
    },
    dataPositions() {
      this.setSourceMapData("positions", this.dataPositions);
    },
    dataPositionsPath() {
      this.setSourceMapData("positionsPath", this.dataPositionsPath);
    },
    dataAccuracys() {
      this.setSourceMapData("accuracys", this.dataAccuracys);
    },
    dataPrelevementToDo() {
      this.setSourceMapData("prelevementToDo", this.dataPrelevementToDo);
    },
    dataPrelevementDone() {
      this.setSourceMapData("prelevementDone", this.dataPrelevementDone);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.map {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.actionToDo {
  position: absolute;
  bottom: 40px;
  right: 140px;
}

#myMap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, rgba(9, 200, 152, 0.8) 0%, rgba(12, 147, 242, 0.8) 100%);
}

.tools {
  position: fixed;
  bottom: 0;
  right: 0px;
  margin: 40px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.drawTools {
  position: absolute;
  top: 0;
  right: 40px;
  margin: 10px;
}

.infoPosition {
  background: white;
  border-radius: 50%;
  height: auto;
  z-index: 100;
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 10px;
  cursor: pointer;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: -1px;
  text-align: center;
  line-height: 1;
  display: flex;
  align-items: center;
}

.logo {
  width: 70px;
  height: 70px;
  background: white;
  position: absolute;
  top: 90px;
  left: 0;
  margin: 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.5);
  cursor: pointer;

  img {
    width: 100%;
  }
}

.edit {
  position: absolute;
  left: 90px;
  top: 15px;
}

.diameter {
  font-size: 13px;
  color: #999;
  line-height: 1;
  margin-top: 5px;
}
</style>